export default {
	en: {
		home: "",
		summary: "",
		privacy: "",
		resultsLeft: "",
		resultsRight: "",
		footer1: "",
		footer2: "",
		contactMe: "",
		contactEmail: "",
		contactPhoneNumber: "",
	},
	nl: {
		home: "",
		summary: "",
		privacy: "",
		resultsLeft: "",
		resultsRight: "",
		footer1: "",
		footer2: "",
		contactMe: "",
		contactEmail: "",
		contactPhoneNumber: ""
	}
};
